import React, { Component } from 'react'
import { Breadcrumb } from 'antd'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'

const breadcrumbNameMap = {
    '/institution/merchantList': '商户管理',
    '/institution/deviceList': '设备管理',
    '/institution/deviceList/detail': '设备详情',
    '/institution/reportList': '报告列表',
    '/institution/reportList/detail': '用户报告',
    '/institution/reportList/userReport': '用户报告',
    '/institution/reportList/expertData': '专家数据',
    '/institution/reportList/leap': '参数化鞋垫设计系统',
    '/institution/statistics': '数据管理',
    '/institution/exportData': '数据导出',

    '/institution/reportList/pressure': '用户报告',
    '/institution/setting': '后台设置',
    '/institution/changePassword': '修改密码',

    '/merchant/reportList': '报告列表',
    '/merchant/reportList/detail': '用户报告',
    '/merchant/reportList/userReport': '用户报告',
    '/merchant/reportList/expertData': '专家数据',
    '/merchant/reportList/leap': '参数化鞋垫设计系统',
    '/merchant/reportList/pressure': '用户报告',
    '/merchant/statistics': '数据管理',
    
    '/merchant/examineeList': '用户列表',
    '/merchant/examineeList/detail': '用户详情',
    '/merchant/examineeList/detail/silizhuReport': '报告详情',
    '/merchant/setting': '后台设置',
    '/merchant/changePassword': '修改密码',
}

class BreadcrumbCustom extends Component<RouteComponentProps> {
    
    render () {
        const { history } = this.props;
        let pathname = history.location.pathname;

        let pathSnippets = pathname.split('/').filter((i) => i);
        let breadcrumbItems = pathSnippets.map((_, index) => {

            if(index == 0) return ;
            let url = pathSnippets.slice(0, index + 1).join('/');
            let key = `/${url}`;
            let length = pathSnippets.length;

            if(index + 1 === length || index === 2) {
                return (
                    <Breadcrumb.Item key={key}>
                        {breadcrumbNameMap[key]}
                    </Breadcrumb.Item>
                )
            }
            else {
                return (
                    <Breadcrumb.Item key={key}>
                        <Link to={key}>
                            {breadcrumbNameMap[key]}
                        </Link>
                    </Breadcrumb.Item>
                )
            }
        })

        return (
            <span>
                <Breadcrumb>{breadcrumbItems}</Breadcrumb>
            </span>
        )
    }
}

export default withRouter(BreadcrumbCustom)